import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  className?: string;
  children: React.ReactNode;
  openNewWindow?: boolean;
  to: string;
};

export const NavOrExternalLink = (props: Props) => {
  const { className, to, children, openNewWindow } = props;
  const isAnchor = /^https?:\/\//.test(to) || openNewWindow;
  const target = openNewWindow ? '_blank' : undefined;

  if (!isAnchor) {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <a href={to} className={className} rel="noopener noreferrer" target={target}>
      {children}
    </a>
  );
};
